
import React from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import { useSuperAdminSettings } from '@/hooks/useSuperAdminSettings';
import SupportManagementPage from '@/components/support/SupportManagementPage';

const SuperAdminSupportManagement = () => {
  const { user, handleLogout, isLoading } = useSuperAdminSettings();
  
  return (
    <SuperAdminLayout 
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="support"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Support Management</h1>
          <p className="text-gray-600">
            Manage all support tickets and customer inquiries
          </p>
        </div>
        
        {isLoading ? (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : (
          <SupportManagementPage />
        )}
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminSupportManagement;
